import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import DefectiveGroupList from './DefectiveGroupList'

const DefectiveGroupInfo = ({ defectiveGroups }) => {
    return (
        <TableContainer component={Paper}>
            <Table aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell>Date</TableCell>
                        <TableCell>Group Name</TableCell>
                        <TableCell>Note</TableCell>
                        <TableCell style={{ width: '50px' }}></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {defectiveGroups.map((defectiveGroup) => (
                        <DefectiveGroupList
                            defectiveGroup={defectiveGroup}
                            key={defectiveGroup.id}
                        />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default DefectiveGroupInfo
